var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-btn',{staticClass:"phone-btn pa-0",class:{
			'action lighten-2 phone-btn-inactive': !_vm.active,
			'info white--text phone-btn-active': _vm.active
		},attrs:{"changes-form":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"caller-selection-number",class:{
					'text--text phone-btn-inactive': !_vm.active,
		    }},[(_vm.number !== '*')?[_vm._v(" "+_vm._s(_vm.number)+" ")]:[_vm._v(" "+_vm._s(_vm.l.t('app.no', 'No'))+" "),_c('br'),_vm._v(" "+_vm._s(_vm.l.t('app.input', 'input'))+" ")]],2),(_vm.number !== '*')?_c('div',{staticClass:"caller-selection-letters"},[_vm._v(" "+_vm._s(_vm.keys[_vm.number])+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }